import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("product_properties");

export const productPropertiesApi = createApi({
  reducerPath: "productProperties", // Unique path for this API slice
  baseQuery: requestBaseQuery,
  tagTypes: ["property"],
  endpoints: (builder) => ({
    getAllProductProperties: builder.query({
      query: () => ({
        type: "GET",
        order: [{ column: "created_at", ascending: true }],
      }),
      providesTags: [{ type: "property", id: "LIST" }],
      keepUnusedDataFor: 3600,
    }),
    addProductProperty: builder.mutation({
      query: (propertyDetails) => ({
        type: "POST",
        data: propertyDetails,
      }),
      invalidatesTags: [{ type: "property", id: "LIST" }],
    }),
    getProductProperty: builder.query({
      query: ({ filter, offset, pageLimit }) => ({
        type: "GET",
        filters: filter ?? undefined,
        offset: offset ?? 0,
        limit: pageLimit ?? 10,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "property", id })), // Provide individual product tags
              { type: "property", id: "LIST" }, // Provide LIST tag for the whole product list
            ]
          : [{ type: "property", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAllProductPropertiesQuery,
  useAddProductPropertyMutation,
  useGetProductPropertyQuery
} = productPropertiesApi;
